const ROOT = 'INVOICES_ATTENTION_REQUIRED_';

const actions = {
  LOAD_ATTENTION_REQUIRED_REQUEST: `${ROOT}LOAD_ATTENTION_REQUIRED_REQUEST`,
  LOAD_ATTENTION_REQUIRED_SUCCESS: `${ROOT}LOAD_ATTENTION_REQUIRED_SUCCESS`,
  LOAD_ATTENTION_REQUIRED_ERROR: `${ROOT}LOAD_ATTENTION_REQUIRED_ERROR`,
} as const;

export default actions;
